import React from "react"
import { connect } from "react-redux"
import Card, { TitleCard } from "../../core/Card"
import { push, goBack } from "react-router-redux"
import Line from "../../core/Line"
import {
  ForwardIcon,
  Icon,
  PlusIcon,
  MarkerIcon,
  BankCardIcon
} from "../../core/icons"
import { BrowserRouter as Router, Route, Link } from "react-router-dom"
import {
  Slider,
  Select,
  Button,
  Col,
  Row,
  Popover,
  Icon as AIcon,
  Switch,
  message,
  Popconfirm
} from "antd"
import { toggle, unlink, updateLogin, refresh } from "./actions"
import Accounts from "./Accounts"

const BankCard = ({
  refresh,
  institution_name,
  last_sync,
  unlink,
  updateLogin,
  tokenId,
  isRefreshing,
  isFetching
}) => (
  <div>
    <TitleCard sticky showBackButton>
      <h1>{institution_name}</h1>
    </TitleCard>

    <Card showLoadingIcon={isFetching}>
      <h2>Accounts</h2>
      <Accounts tokenId={tokenId} />
    </Card>

    <Card>
      <h2>Options</h2>
      <Line onClick={refresh}>
        <Col span={14}>Refresh</Col>
        <Col span={8}>
          {last_sync && (
            <span style={{ fontSize: 14, opacity: 0.5 }}>
              {isRefreshing ? `refreshing...  ` : `last refresh: ${last_sync}`}
              {isRefreshing && <AIcon type="loading" />}
            </span>
          )}
        </Col>
        <Col span={1}>
          <ForwardIcon />
        </Col>
      </Line>

      <Line onClick={updateLogin}>
        <Col span={14}>Update Login</Col>
        <Col span={8} />
        <Col span={1}>
          <ForwardIcon />
        </Col>
      </Line>

      <Popconfirm
        title={
          <div>
            <h4>Are you sure?</h4>
            Your transaction history will not be erased.
          </div>
        }
        placement="top"
        onConfirm={unlink}
        okType="danger"
        onCancel={() => {
          console.log("canceled")
        }}
        okText="Unlink"
        cancelText="Cancel"
      >
        {/* <Button type="danger" icon="delete"></Button> */}
        <Line>
          <Col span={14}>Unlink Institution</Col>
          <Col span={8} />
          <Col span={1}>
            <ForwardIcon />
          </Col>
        </Line>
      </Popconfirm>
    </Card>
  </div>
)

const mapDispatchToProps = (
  dispatch,
  {
    match: {
      params: { tokenId }
    }
  }
) => {
  return {
    refresh: () => dispatch(refresh(tokenId)),
    updateLogin: () => dispatch(updateLogin(tokenId)),
    unlink: () => {
      dispatch(unlink(tokenId)).then(() => {
        message.success("Successfully unlinked institution.")
        dispatch(push("/account/bank-card"))
      })
    }
  }
}

const mapStateToProps = (
  {
    account: {
      bankCard: { isRefreshing }
    },
    models: {
      user: { institution_users, isFetching }
    }
  },
  {
    match: {
      params: { tokenId }
    }
  }
) => {
  return {
    ...institution_users.find(({ token_id }) => token_id == tokenId),
    tokenId,
    isRefreshing,
    isFetching
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BankCard)



// WEBPACK FOOTER //
// ./src/account/bank-card/BankCard.js